import { createSelector } from 'reselect';
import { CreativesState } from './types';
import { CREATIVES_PENDING_STATUSES } from './creatives.constants';

export const getCreatives = (state: any): CreativesState => state.creatives;
const getCurrentCreatives = (state: any) => getCreatives(state).creatives;
export const getCreative = (state: any): CreativesState['creative'] => state.creatives.creative;
export const getCreativesActionProgress = createSelector(
    getCreatives,
    (
        creatives,
    ): {
        renamingInProgress: CreativesState['renamingInProgress'];
        duplicationInProgress: CreativesState['duplicationInProgress'];
        deleteInProgress: CreativesState['deleteInProgress'];
        addingInProgress: CreativesState['addingInProgress'];
    } => ({
        renamingInProgress: creatives.renamingInProgress,
        duplicationInProgress: creatives.duplicationInProgress,
        deleteInProgress: creatives.deleteInProgress,
        addingInProgress: creatives.addingInProgress,
    }),
);
export const getCreativesSelection = createSelector(
    getCreatives,
    (
        creatives,
    ): {
        selectedCreatives: CreativesState['creatives'];
        selectedCreativesIds: CreativesState['checked'];
    } => ({
        selectedCreatives: creatives?.creatives.filter((creative) => creative.checked),
        selectedCreativesIds: creatives?.checked,
    }),
);

export const isCreativesFirstLoaded = (state): CreativesState['firstLoad'] => state.creatives.firstLoad;

export const getPendingCreatives = createSelector(getCurrentCreatives, (creatives) =>
    creatives
        .filter((creative) => CREATIVES_PENDING_STATUSES.includes(creative.thumbnailStatus))
        .map((creative) => creative.id),
);
